import { FormattedMessage } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Button, Link, Typography } from '@carto/meridian-ds/components'
import { ErrorBoundary } from 'features/common/ui/ErrorBoundary'
import { TrackJS } from 'trackjs'
import BGImage from 'assets/img/grid.webp'
import ErrorImage from 'assets/img/workflow_error.svg'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import settings from 'settings'

export function WorkflowErrorBoundary({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary FallBackComponent={(error) => <ErrorFallback {...(error || {})} />}>{children}</ErrorBoundary>
}

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.default,
  backgroundImage: `url(${BGImage})`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

const Content = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: theme.spacing(52),
  padding: theme.spacing(6, 4, 4, 4)
}))

export function ErrorFallback({ error }: { error: Error }) {
  const navigate = useNavigate()

  useEffect(() => {
    if (settings.enableTrackJs && error) {
      TrackJS.track(error)
    }
  }, [error])

  return (
    <Root>
      <Content>
        <img src={ErrorImage} />
        <Box mt={2}>
          <Typography variant="h5">Whoops!</Typography>
        </Box>
        <Box mt={1}>
          <Typography variant="body1" color="textSecondary" align="center">
            {error?.message ? error.message : <FormattedMessage id="workflows.errors.global" />}
          </Typography>
        </Box>
        <Box mt={3}>
          <Button size="medium" variant="contained" color="primary" onClick={() => navigate('/')}>
            <FormattedMessage id="common.button.okGoHome" />
          </Button>
        </Box>
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary" align="center">
            <FormattedMessage
              id="common.utils.contactSupport"
              values={{
                contactLink: (
                  <Link href="mailto:support@carto.com" underline="none">
                    support@carto.com
                  </Link>
                )
              }}
            />
          </Typography>
        </Box>
      </Content>
    </Root>
  )
}
